import ProjectManagerCell from '../../../project/project/project_manager_cell/project_manager_cell.jsx'

export default ProjectManagerCell
